"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShortcutVisitedPlaces = exports.getVisitedPlaceDescription = void 0;
const get_1 = __importDefault(require("lodash/get"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const i18next_1 = __importDefault(require("i18next"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const DateTimeUtils_1 = require("chaire-lib-common/lib/utils/DateTimeUtils");
const helper_1 = require("./helper");
/**
 * FIXME: Add these new parameters to the frontendHelper function
 * getVisitedPlaceDescription in evolution-frontend
 *
 * Get the visited place shortcut description
 * Shortcut should not show the activity since it can make the respondent
 * think they cannot do another activity at the same place, so we put only
 * the place name, the person nickname and the times.
 * However, if the place name is absent, we show the activity name.
 * @param visitedPlace The visited place for which to get the description
 * @param person The person who went to this visited place
 * @param options Configuration options for the description
 * @param options.withTimes Whether to add the times to the description (default: false)
 * @param options.withActivity Whether to add the activity name to the description (default: true)
 * If place name is empty, it will show activity name, even if this flag is false.
 * If place name is not empty, it will only be shown if this flag is true.
 * @param options.withNickname Whether to include the person's nickname (default: true)
 * @param options.allowHtml Whether the description can contain HTML characters (default: true)
 * @returns The formatted description string
 */
const getVisitedPlaceDescription = function (visitedPlace, person, options = {}) {
    const { withTimes = false, withActivity = true, withNickname = true, allowHtml = true } = options;
    const contentParts = [];
    // Add place name (if available)
    if (visitedPlace.name) {
        contentParts.push(allowHtml ? `<em>${visitedPlace.name}</em>` : visitedPlace.name);
    }
    // Add nickname
    if (withNickname && person && person.nickname) {
        contentParts.push(person.nickname);
    }
    // Add activity (always last before times)
    // If no place name, activity is required; if place name exists, show activity only if withActivity is true
    if (!visitedPlace.name || withActivity) {
        const activityText = i18next_1.default.t(`survey:visitedPlace:activities:${visitedPlace.activity}`);
        if (activityText) {
            contentParts.push(activityText);
        }
    }
    // Add times if requested and available
    let timesPart = '';
    if (withTimes) {
        const arrivalTime = visitedPlace.arrivalTime !== undefined && visitedPlace.arrivalTime !== null
            ? (0, DateTimeUtils_1.secondsSinceMidnightToTimeStr)(visitedPlace.arrivalTime)
            : '';
        const departureTime = visitedPlace.departureTime !== undefined && visitedPlace.departureTime !== null
            ? (0, DateTimeUtils_1.secondsSinceMidnightToTimeStr)(visitedPlace.departureTime)
            : '';
        if (arrivalTime || departureTime) {
            let timeString = '';
            if (arrivalTime && departureTime) {
                timeString = `${arrivalTime} -> ${departureTime}`;
            }
            else if (arrivalTime) {
                timeString = `${arrivalTime} ->`;
            }
            else if (departureTime) {
                timeString = `-> ${departureTime}`;
            }
            timesPart = ` (${timeString})`;
        }
    }
    return contentParts.join(' • ') + timesPart;
};
exports.getVisitedPlaceDescription = getVisitedPlaceDescription;
/**
 * @param interview
 * @returns
 */
const getShortcutVisitedPlaces = (interview) => {
    const currentPerson = odSurveyHelper.getPerson({ interview });
    const currentJourney = odSurveyHelper.getActiveJourney({ interview });
    const currentVisitedPlace = odSurveyHelper.getActiveVisitedPlace({
        interview,
        journey: currentJourney
    });
    const previousVisitedPlace = odSurveyHelper.getPreviousVisitedPlace({
        journey: currentJourney,
        visitedPlaceId: currentVisitedPlace._uuid
    });
    const previousVisitedPlaceGeography = previousVisitedPlace
        ? odSurveyHelper.getVisitedPlaceGeography({
            visitedPlace: previousVisitedPlace,
            interview,
            person: currentPerson
        })
        : undefined;
    const previousVisitedPlaceCoordinates = (0, get_1.default)(previousVisitedPlaceGeography, 'geometry.coordinates', null);
    const visitedAndUsualPlacesArrayAndByPersonId = (0, helper_1.getHouseholdVisitedAndUsualPlacesArrayAndByPersonId)(interview);
    const shortcutsOrderedByPerson = [];
    // Add usual places of the persons
    for (const personId in visitedAndUsualPlacesArrayAndByPersonId.usualPlacesByPersonId) {
        const person = odSurveyHelper.getPerson({ interview, personId });
        const personUsualPlaces = visitedAndUsualPlacesArrayAndByPersonId.usualPlacesByPersonId[personId];
        for (let i = 0, count = personUsualPlaces.length; i < count; i++) {
            const visitedPlace = personUsualPlaces[i];
            const visitedPlaceGeography = odSurveyHelper.getVisitedPlaceGeography({ visitedPlace, interview, person });
            const visitedPlaceCoordinates = (0, get_1.default)(visitedPlaceGeography, 'geometry.coordinates', null);
            const visitedPlaceDescription = (0, exports.getVisitedPlaceDescription)(visitedPlace, person, {
                withTimes: true,
                withActivity: false,
                withNickname: true,
                allowHtml: false
            });
            if (visitedPlace._uuid !== currentVisitedPlace._uuid &&
                !(0, LodashExtensions_1._isBlank)(visitedPlaceCoordinates) &&
                ((0, LodashExtensions_1._isBlank)(previousVisitedPlaceCoordinates) ||
                    !(0, isEqual_1.default)(visitedPlaceCoordinates, previousVisitedPlaceCoordinates))) {
                shortcutsOrderedByPerson.push({
                    personNickname: person.nickname,
                    visitedPlaceId: `household.persons.${personId}.${visitedPlace.activity === 'workUsual' ? 'usualWorkPlace' : 'usualSchoolPlace'}`,
                    description: visitedPlaceDescription
                });
            }
        }
    }
    // Add the visited places of the persons
    for (const personId in visitedAndUsualPlacesArrayAndByPersonId.visitedPlacesByPersonId) {
        const person = odSurveyHelper.getPerson({ interview, personId });
        const personVisitedPlaces = visitedAndUsualPlacesArrayAndByPersonId.visitedPlacesByPersonId[personId];
        for (let i = 0, count = personVisitedPlaces.length; i < count; i++) {
            const visitedPlace = personVisitedPlaces[i].visitedPlace;
            // Ignore places that are already shortcuts or usual places
            if (visitedPlace.shortcut ||
                (visitedPlace.activity === 'workUsual' &&
                    person.usualWorkPlace &&
                    person.usualWorkPlace.geography) ||
                (visitedPlace.activity === 'schoolUsual' &&
                    person.usualSchoolPlace &&
                    person.usualSchoolPlace.geography)) {
                continue;
            }
            const visitedPlaceGeography = odSurveyHelper.getVisitedPlaceGeography({ visitedPlace, interview, person });
            const visitedPlaceCoordinates = (0, get_1.default)(visitedPlaceGeography, 'geometry.coordinates', null);
            const visitedPlaceDescription = (0, exports.getVisitedPlaceDescription)(visitedPlace, person, {
                withTimes: true,
                withActivity: false,
                withNickname: true,
                allowHtml: false
            });
            if (visitedPlace.activity !== 'home' &&
                visitedPlace.activity !== 'workOnTheRoad' &&
                visitedPlace._uuid !== currentVisitedPlace._uuid &&
                !(0, LodashExtensions_1._isBlank)(visitedPlaceCoordinates) &&
                ((0, LodashExtensions_1._isBlank)(previousVisitedPlaceCoordinates) ||
                    !(0, isEqual_1.default)(visitedPlaceCoordinates, previousVisitedPlaceCoordinates))) {
                shortcutsOrderedByPerson.push({
                    personNickname: person.nickname,
                    visitedPlaceId: `household.persons.${personId}.journeys.${personVisitedPlaces[i].journey._uuid}.visitedPlaces.${visitedPlace._uuid}`,
                    description: visitedPlaceDescription
                });
            }
        }
    }
    return shortcutsOrderedByPerson;
};
exports.getShortcutVisitedPlaces = getShortcutVisitedPlaces;
